<script setup>

import { onMounted,ref } from 'vue';
  onMounted(()=>{
        $('body').attr('class','page-template-default page page-id-28570 mega-menu-primary-navigation invest-in-share-market')
        require("@/assets/js/invest-in-share-market.js")
  })
</script>
<template>
  <main class="upstox-design-base upstox-homepage invest-in-share-new">
    <section class="banner-new container_fld">
      <div class="container coantainer_sec">
        <div class="row">
          <div class="col-md-7 col-sm-7 pddg_col">
            <div class="banner_txt">
              <div
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-duration="2000"
                data-aos-offset="0"
              >
                <div class="btn_pddg"></div>
                <h1>Invest Right, Invest Now</h1>
                <h2 class="new-title-paragraph desktop-content">
                  Open a <span>FREE*</span> Demat and Trading account to invest
                  in Stocks, Mutual Funds, IPOs and more
                </h2>
                <form onsubmit="return proceedWithLazyLogin(event, this)">
                  <div class="form-row">
                    <div class="form-group invest-group">
                      <input
                        type="tel"
                        onkeypress="return isNumber(event)"
                        name="phone"
                        id="txtcontact"
                        class="form-control"
                        maxlength="10"
                        placeholder="Enter your mobile number"
                      />
                    </div>
                    <button
                      type="submit"
                      class="btn prple_btn animation-btn desktop-btn"
                    >
                      Sign Up
                    </button>
                  </div>
                  <div class="error-message" id="error-message"></div>
                  <p class="desktop-content">
                    By Signing up you agree to our
                    <a
                      href="/terms-of-use-and-privacy-policy/"
                      class="terms-link"
                      >Terms and Conditions</a
                    >
                  </p>

                  <p class="mobile-content mobile-form-para">
                    By signing up you agree to receive transaction updates on
                    Whatsapp. You may also receive a call from an Upstox
                    representative to help you with the account opening process.
                  </p>
                  <!-- responsive-button -->
                  <button
                    type="submit"
                    class="btn prple_btn mbile-hide mobile-btn"
                  >
                    Sign Up
                  </button>
                  <!-- responsive-button -->
                </form>
                <!-- responsive-button -->
                <!-- responsive-button -->
                <ul class="list-unstyled">
                  <li class="first-list desktop-content">
                    <h5>₹0*</h5>
                    <span>Commission on Mutual Funds and IPO</span>
                  </li>
                  <li class="second-list desktop-content">
                    <h5>₹20*</h5>
                    <span
                      >Per order on Equity, F&amp;O, Commodity and
                      Currency</span
                    >
                  </li>
                  <li class="first-list mobile-content">
                    <h5>₹0*</h5>
                    <span>Commission on Mutual Funds and IPO</span>
                  </li>
                  <li class="second-list mobile-content">
                    <h5>₹20</h5>
                    <span
                      >Per order on Equity, F&amp;O, Commodity and
                      Currency</span
                    >
                  </li>
                  <li class="third-list">
                    <h5>
                      4.5+<span>
                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/mutual-fund-new/star_icon.svg"
                          alt="star-icon"
                      /></span>
                    </h5>
                    <span>Avg. App Rating</span>
                  </li>
                  <li class="last-list">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-fund-new/global_tiger.svg"
                      alt="global-icon"
                    />
                    <span>Backed by the best</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-5 col-sm-5 pddg_col desktop-content">
            <picture class="dsktp-hide new-banner-img">
              <source
                srcset="
                  https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/Image-Container.webp
                "
                type="image/webp"
                rel="preload"
                fetchpriority="high"
              />

              <img
                src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/Image-Container.png"
                alt="banner-img"
                rel="preload"
                fetchpriority="high"
                as="image"
              />
            </picture>
            <!-- responsive-img -->
            <picture class="mbile-hide">
              <source
                srcset="
                  https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/new-banner.webp
                "
                class="img-responsive"
                type="image/webp"
                rel="preload"
                fetchpriority="high"
              />

              <img
                src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/new-banner.png"
                class="img-responsive"
                alt="upstox-img"
                rel="preload"
                fetchpriority="high"
                as="image"
              />
            </picture>

            <!-- responsive-img -->
          </div>
        </div>
      </div>
      <div class="col-md-5 col-sm-5 pddg_col mobile-content mobile-space">
        <!-- responsive-img -->
        <picture class="mbile-hide">
          <source
            srcset="
              https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/new-banner.webp
            "
            class="img-responsive"
            type="image/webp"
            rel="preload"
            fetchpriority="high"
          />

          <img
            src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/new-banner.png"
            class="img-responsive"
            alt="upstox-img"
            rel="preload"
            fetchpriority="high"
            as="image"
          />
        </picture>

        <!-- responsive-img -->
      </div>
    </section>

    <!-- upstox-toggle-btn Section Start here -->
    <section class="upstox-toggle-btn-sec">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="toggle-content">
              <div class="pro-logo-img">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/logo-gray.png"
                  class="img-responsive toggle-color gray-image"
                  alt="banner-img"
                  loading="lazy"
                />
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/logo-color.svg"
                  class="img-responsive toggle-color colored-img"
                  alt="banner-img"
                  loading="lazy"
                />
              </div>
              <div class="toggle-img">
                <div class="switch">
                  <input type="checkbox" checked="" />
                  <span class="slider round"></span>
                </div>
              </div>
              <div class="black-logo">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/pro-logo.png"
                  class="img-responsive"
                  alt="banner-img"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- upstox-toggle-btn Section end here -->
    <!-- upstox investor video Section Start here -->
    <section class="investor-video-section">
      <div class="container">
        <div class="investor-title-content">
          <h2 class="desktop-content">Upstox for investors</h2>
          <p class="desktop-content">
            We understand that investors and traders have different needs, which
            is why<br />we've created a separate mode called Upstox for
            Investors
          </p>
          <h2 class="mobile-content">Upstox for investors</h2>
          <p class="mobile-content">
            We understand that investors and traders have different needs, which
            is why we've created a separate mode called Upstox for Investors
          </p>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-4">
            <div class="investor-video-column">
              <div class="discovery-img">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/tracker.svg"
                  class="mw-100"
                  alt="family"
                  loading="lazy"
                />
              </div>
              <h3 class="desktop-content">Wealth Tracker</h3>
              <p class="desktop-content">
                Track all wealth on one app, import external Mutual Funds and
                link Bank Accounts
              </p>
            </div>
          </div>
          <div class="col-md-4 col-sm-4">
            <div class="investor-video-column">
              <div class="discovery-img">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/checklist.svg"
                  class="mw-100"
                  alt="family"
                  loading="lazy"
                />
              </div>
              <h3 class="desktop-content">Ready-made Portfolios</h3>
              <p class="desktop-content">
                Based on your risk appetite, find curated Mutual Fund portfolios
                to start SIPs in
              </p>
            </div>
          </div>
          <div class="col-md-4 col-sm-4">
            <div class="investor-video-column last-column-video">
              <div class="discovery-img">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/saving-file.svg"
                  class="mw-100"
                  alt="family"
                  loading="lazy"
                />
              </div>
              <h3 class="desktop-content">SIP Mode</h3>
              <p class="desktop-content">
                Stay disciplined with your investments by choosing SIP for
                Stocks and Mutual Funds
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- upstox investor video Section end here -->
    <!-- start of toggle section -->
    <section class="trader-upstock">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-xs-12 trader-sub"></div>
        </div>
      </div>
    </section>
    <!-- end of toggle section -->

    <section class="invest_section invest-sec1 stocks_main_cls">
      <div class="container container_primary">
        <div class="dsktp-hide">
          <div class="sections">
            <div class="pddg_sec invest" id="invest">
              <div class="row">
                <div class="col-md-5">
                  <div class="tab-content">
                    <div
                      role="tabpanel"
                      class="tab-pane fade"
                      id="invest-idea-stocks"
                    >
                      <picture class="">
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/stock-desk1.webp
                          "
                          class="img-responsive"
                          media="(max-width: 767px)"
                          alt="upstox-img"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/stock-desk1.png
                          "
                          class="img-responsive"
                          media="(min-width: 768px)"
                          alt="upstox-img"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/stock-desk1.png"
                          class="img-responsive"
                          alt="upstox-img"
                        />
                      </picture>
                    </div>
                    <div
                      role="tabpanel"
                      class="tab-pane fade active in"
                      id="new-sights-stocks"
                    >
                      <picture class="">
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/stock-desk2.webp
                          "
                          class="img-responsive"
                          media="(max-width: 767px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/stock-desk2.png
                          "
                          class="img-responsive"
                          media="(min-width: 768px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/stock-desk2.png"
                          class="img-responsive"
                          loading="lazy"
                          alt="upstox-img"
                        />
                      </picture>
                    </div>
                    <div
                      role="tabpanel"
                      class="tab-pane fade"
                      id="order-place-stocks"
                    >
                      <picture class="">
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/stock-desk3.webp
                          "
                          class="img-responsive"
                          media="(max-width: 767px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/stock-desk3.png
                          "
                          class="img-responsive"
                          media="(min-width: 768px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/stock-desk3.png"
                          class="img-responsive"
                          loading="lazy"
                          alt="upstox-img"
                        />
                      </picture>
                    </div>
                  </div>
                </div>

                <div class="col-md-7">
                  <div class="int_tab_list">
                    <h2 class="h2_heading">Stocks</h2>
                    <p class="p_txt">
                      Choosing from 5000+ Stocks is tough. <br />We've made the
                      search easier
                    </p>
                    <ul class="list-unstyled" role="tablist">
                      <li role="presentation" class="">
                        <a
                          href="#invest-idea-stocks"
                          aria-controls="invest-idea-stocks"
                          role="tab"
                          data-toggle="tab"
                          aria-expanded="false"
                        >
                          <h3>Discover stocks easily</h3>
                          <ul class="list-unstyled">
                            <li>With curated stock lists such as</li>
                          </ul>
                        </a>
                      </li>
                      <li role="presentation" class="active">
                        <a
                          href="#new-sights-stocks"
                          aria-controls="new-sights-stocks"
                          role="tab"
                          data-toggle="tab"
                          aria-expanded="true"
                        >
                          <h3>Invest in them confidently</h3>
                          <ul class="list-unstyled">
                            <li>
                              With 6-point investment checklist and analyst
                              ratings to buy, sell or hold a stock
                            </li>
                          </ul>
                        </a>
                      </li>
                      <li role="presentation" class="">
                        <a
                          href="#order-place-stocks"
                          aria-controls="order-place-stocks"
                          role="tab"
                          data-toggle="tab"
                          aria-expanded="false"
                        >
                          <h3>Stock like you shop</h3>
                          <ul class="list-unstyled">
                            <li>
                              Simplified and intuitive buying and selling
                              experience
                            </li>
                          </ul>
                        </a>
                      </li>
                    </ul>
                    <a
                      href="/stocks/"
                      class="btn prple_outline_btn uplearn_btn"
                      target="_blank"
                      >Explore Stocks</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mbile-hide">
          <div class="mbl_invest">
            <div class="text-center">
              <h2 class="h2_heading">Stocks</h2>
              <p class="p_txt">
                Choosing from 5000+ Stocks is tough. We've made the search
                easier
              </p>
            </div>
            <div class="invest-slide-arrow" id="invest-slide-stock">
              <div
                class="invest_next invest-arrow invest-next-stocks active"
                id="invest_next_stocks"
              >
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/invest-next.svg"
                  class="img-responsive"
                  alt="invest-next"
                  loading="lazy"
                />
              </div>

              <div
                class="invest_prev invest-arrow invest-next-stocks"
                id="invest_prev_stocks"
              >
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/invest-prev.svg"
                  class="img-responsive"
                  alt="invest-prev"
                  loading="lazy"
                />
              </div>
            </div>
            <div class="pddg_sec invest tab-sec1" id="invest-funds-stocks">
              <div class="row">
                <div class="col-md-5">
                  <div class="mbl_sec_lists">
                    <ul
                      class="list-unstyled-stocks"
                      id="list-unstyled-stocks"
                      role="tablist"
                    >
                      <li role="presentation" class="active">
                        <a
                          href="#invest-idea-mobile-stocks"
                          aria-controls="invest-idea-mobile-stocks"
                          role="tab"
                          data-toggle="tab"
                        >
                          <h6>Powerful Charting</h6>
                        </a>
                      </li>

                      <li role="presentation">
                        <a
                          href="#new-sights-mobile-stocks"
                          aria-controls="new-sights-mobile-stocks"
                          role="tab"
                          data-toggle="tab"
                        >
                          <h6>Powerful Charting</h6>
                        </a>
                      </li>
                      <li role="presentation">
                        <a
                          href="#order-place-mobile-stocks"
                          aria-controls="order-place-mobile-stocks"
                          role="tab"
                          data-toggle="tab"
                        >
                          <h6>Powerful Charting</h6>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-7 trades-power-stocks">
                  <div class="tab-content">
                    <div
                      role="tabpanel"
                      class="tab-pane fade in active"
                      id="invest-idea-mobile-stocks"
                    >
                      <ul class="list-unstyled">
                        <li>
                          These are the best funds shortlisted based on in-depth
                          risk and return analysis
                        </li>
                      </ul>
                      <picture>
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/stock-mob.webp
                          "
                          class="img-responsive"
                          media="(min-width: 767px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/stock-mob.png
                          "
                          class="img-responsive"
                          media="(min-width: 768px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/stock-mob.png"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </picture>

                      <div class="rated-mobile-sub">
                        <h3>Discover stocks easily</h3>
                        <p>With curated stock lists such as</p>
                      </div>
                    </div>
                    <div
                      role="tabpanel"
                      class="tab-pane fade"
                      id="new-sights-mobile-stocks"
                    >
                      <ul class="list-unstyled">
                        <li>Analyst ratings</li>
                        <li>Investment checklist</li>
                        <li>Risk &amp; return related info</li>
                      </ul>
                      <picture>
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/stock-mob1.webp
                          "
                          class="img-responsive"
                          media="(min-width: 767px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/stock-mob1.png
                          "
                          class="img-responsive"
                          media="(min-width: 768px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/stock-mob1.png"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </picture>

                      <div class="rated-mobile-sub">
                        <h3>Invest in them confidently</h3>
                        <p>
                          With 6-point investment checklist and analyst ratings
                          to buy, sell or hold a stock
                        </p>
                      </div>
                    </div>
                    <div
                      role="tabpanel"
                      class="tab-pane fade"
                      id="order-place-mobile-stocks"
                    >
                      <ul class="list-unstyled">
                        <li>Open 24/7</li>
                        <li>SIP mode for Stocks &amp; Mutual Funds</li>
                        <li>Pay via UPI</li>
                      </ul>
                      <picture>
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/stock-mob2.webp
                          "
                          class="img-responsive"
                          media="(min-width: 767px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/stock-mob2.png
                          "
                          class="img-responsive"
                          media="(min-width: 768px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/stock-mob2.png"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </picture>

                      <div class="rated-mobile-sub">
                        <h3>Stock like you shop</h3>
                        <p>
                          Simplified and intuitive buying and selling experience
                        </p>
                      </div>
                    </div>
                  </div>
                  <a
                    href="/stocks/"
                    class="btn prple_outline_btn uplearn_btn"
                    target="_blank"
                    >Explore Stocks</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="invest_section invest-sec1">
      <div class="container container_primary">
        <div class="dsktp-hide">
          <div class="sections">
            <div class="pddg_sec invest" id="invest">
              <div class="row">
                <div class="col-md-7">
                  <div class="int_tab_list">
                    <h2 class="h2_heading">
                      Mutual Funds<span class="new-text">New</span>
                    </h2>
                    <p class="p_txt">
                      2500+ mutual funds! Which one to pick? We've made it easy
                      by doing all the heavy-lifting for you.
                    </p>
                    <ul class="list-unstyled" role="tablist">
                      <li role="presentation" class="">
                        <a
                          href="#invest-idea"
                          aria-controls="invest-idea"
                          role="tab"
                          data-toggle="tab"
                          aria-expanded="false"
                        >
                          <h3>Get Top Rated Funds</h3>
                          <ul class="list-unstyled">
                            <li>
                              Funds shortlisted after conducting in-depth risk
                              and return analysis
                            </li>
                          </ul>
                        </a>
                      </li>
                      <li role="presentation" class="active">
                        <a
                          href="#new-sights"
                          aria-controls="new-sights"
                          role="tab"
                          data-toggle="tab"
                          aria-expanded="true"
                        >
                          <h3>Save up to 2%</h3>
                          <ul class="list-unstyled">
                            <li>
                              With our Direct Plans, invest in the Top Rated
                              funds and save on commissions!
                            </li>
                          </ul>
                        </a>
                      </li>
                      <li role="presentation" class="">
                        <a
                          href="#order-place"
                          aria-controls="order-place"
                          role="tab"
                          data-toggle="tab"
                          aria-expanded="false"
                        >
                          <h3>Start with just ₹100</h3>
                          <ul class="list-unstyled">
                            <li>
                              SIP investments starting at just ₹100/month to
                              help you invest small amounts regularly
                            </li>
                          </ul>
                        </a>
                      </li>
                    </ul>
                    <a
                      href="/mutual-funds/"
                      class="btn prple_outline_btn uplearn_btn"
                      target="_blank"
                      >Explore Mutual Funds</a
                    >
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="tab-content">
                    <div role="tabpanel" class="tab-pane fade" id="invest-idea">
                      <picture>
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/investor-tab1.webp
                          "
                          class="img-responsive"
                          media="(min-width: 767px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/investor-tab1.png
                          "
                          class="img-responsive"
                          media="(min-width: 768px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/investor-tab1.png"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </picture>
                    </div>
                    <div
                      role="tabpanel"
                      class="tab-pane fade active in"
                      id="new-sights"
                    >
                      <picture>
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/save-tab2.webp
                          "
                          class="img-responsive"
                          media="(min-width: 767px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/save-tab2.png
                          "
                          class="img-responsive"
                          media="(min-width: 768px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/save-tab2.png"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </picture>
                    </div>
                    <div role="tabpanel" class="tab-pane fade" id="order-place">
                      <picture>
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/start-tab3.webp
                          "
                          class="img-responsive"
                          media="(min-width: 767px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/start-tab3.png
                          "
                          class="img-responsive"
                          media="(min-width: 768px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/start-tab3.png"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </picture>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mbile-hide">
          <div class="mbl_invest">
            <div class="text-center">
              <h2 class="h2_heading">
                Mutual Funds <span class="new-text">New</span>
              </h2>
              <p class="p_txt">
                2500+ mutual funds! Which one to pick? We've made it easy by
                doing all the heavy-lifting for you.
              </p>
            </div>
            <div class="invest-slide-arrow">
              <div
                class="invest_next invest-arrow invest-next-funds active"
                id="invest_next"
              >
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/invest-next.svg"
                  class="img-responsive"
                  alt="invest-next"
                  loading="lazy"
                />
              </div>

              <div
                class="invest_prev invest-arrow invest-next-funds"
                id="invest_prev"
              >
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/invest-prev.svg"
                  class="img-responsive"
                  alt="invest-prev"
                  loading="lazy"
                />
              </div>
            </div>
            <div class="pddg_sec invest tab-sec1" id="invest-funds">
              <div class="row">
                <div class="col-md-5">
                  <div class="mbl_sec_lists">
                    <ul class="list-unstyled-funds" role="tablist">
                      <li role="presentation" class="active">
                        <a
                          href="#invest-idea-mobile"
                          aria-controls="invest-idea-mobile"
                          role="tab"
                          data-toggle="tab"
                        >
                          <h6>Powerful Charting</h6>
                        </a>
                      </li>
                      <li role="presentation">
                        <a
                          href="#new-sights-mobile"
                          aria-controls="new-sights-mobile"
                          role="tab"
                          data-toggle="tab"
                        >
                          <h6>Powerful Charting</h6>
                        </a>
                      </li>
                      <li role="presentation">
                        <a
                          href="#order-place-mobile"
                          aria-controls="order-place-mobile"
                          role="tab"
                          data-toggle="tab"
                        >
                          <h6>Powerful Charting</h6>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-7 trades-power">
                  <div class="tab-content">
                    <div
                      role="tabpanel"
                      class="tab-pane fade in active"
                      id="invest-idea-mobile"
                    >
                      <ul class="list-unstyled">
                        <li>
                          These are the best funds shortlisted based on in-depth
                          risk and return analysis
                        </li>
                      </ul>
                      <picture>
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/mutual-mob.webp
                          "
                          class="img-responsive"
                          media="(min-width: 767px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/mutual-mob.png
                          "
                          class="img-responsive"
                          media="(min-width: 768px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/mutual-mob.png"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </picture>

                      <div class="rated-mobile-sub">
                        <h3>Get Top Rated Funds</h3>
                        <p>
                          Funds shortlisted after conducting in-depth risk and
                          return analysis
                        </p>
                      </div>
                    </div>
                    <div
                      role="tabpanel"
                      class="tab-pane fade"
                      id="new-sights-mobile"
                    >
                      <ul class="list-unstyled">
                        <li>Analyst ratings</li>
                        <li>Investment checklist</li>
                        <li>Risk &amp; return related info</li>
                      </ul>
                      <picture>
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/mutual-mob1.webp
                          "
                          class="img-responsive"
                          media="(min-width: 767px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/mutual-mob1.png
                          "
                          class="img-responsive"
                          media="(min-width: 768px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/mutual-mob1.png"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </picture>

                      <div class="rated-mobile-sub">
                        <h3>Save up to 2%</h3>
                        <p>
                          With our Direct Plans, invest in the Top Rated funds
                          and save on commissions!
                        </p>
                      </div>
                    </div>
                    <div
                      role="tabpanel"
                      class="tab-pane fade"
                      id="order-place-mobile"
                    >
                      <ul class="list-unstyled">
                        <li>Open 24/7</li>
                        <li>SIP mode for Stocks &amp; Mutual Funds</li>
                        <li>Pay via UPI</li>
                      </ul>
                      <picture>
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/mutual-mob2.webp
                          "
                          class="img-responsive"
                          media="(min-width: 767px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/mutual-mob2.png
                          "
                          class="img-responsive"
                          media="(min-width: 768px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/mutual-mob2.png"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </picture>

                      <div class="rated-mobile-sub">
                        <h3>Start with just ₹100</h3>
                        <p>
                          SIP investments starting at just ₹100/month to help
                          you invest small amounts regularly
                        </p>
                      </div>
                    </div>
                    <a
                      href="/mutual-funds/"
                      class="btn prple_outline_btn uplearn_btn"
                      target="_blank"
                      >Explore Mutual Funds</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="team_sec truths-investing-section desktop-content">
      <div class="mbile-hide">
        <h2 class="h2_heading team-sec-title">Truths of investing</h2>
        <p class="truths-investing-para">
          Why to invest? Where to invest? What to invest in? Follow these truths
          and you're set to begin!
        </p>
        <div
          class="team_mb_truths global_slick_dots owl-carousel owl-theme owl-loaded owl-drag"
        >
          <div class="owl-stage-outer">
            <div
              class="owl-stage"
              style="
                transform: translate3d(0px, 0px, 0px);
                transition: all;
                width: 2887px;
                padding-left: 1px;
                padding-right: 1px;
              "
            >
              <div
                class="owl-item active"
                style="width: 464.667px; margin-right: 16px"
              >
                <div>
                  <div class="card team_mb_card truth-slide-card">
                    <div class="main-truth-content">
                      <div class="truth-slide-content">
                        <h3>
                          A SIP of ₹5000/month started 25 years ago could've
                          made you a crorepati by now
                        </h3>
                        <p>How?</p>
                      </div>
                      <div class="truths-investing-content-area">
                        <p>
                          <span class="check-icon"
                            ><img
                              src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                              class="img-responsive"
                              alt="team-img"
                              loading="lazy" /></span
                          ><span class="check-paragraph"
                            >Start a monthly SIP of ₹5,000</span
                          >
                        </p>
                        <p>
                          <span class="check-icon"
                            ><img
                              src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                              class="img-responsive"
                              alt="team-img"
                              loading="lazy" /></span
                          ><span class="check-paragraph"
                            >Stay invested for 25+ years</span
                          >
                        </p>
                        <p>
                          <span class="check-icon"
                            ><img
                              src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                              class="img-responsive"
                              alt="team-img"
                              loading="lazy" /></span
                          ><span class="check-paragraph"
                            >Aim for equity style returns of 12.5%+ to enjoy the
                            magic of compounding</span
                          >
                        </p>
                      </div>
                    </div>
                    <div class="truth-investing-btn">
                      <p>Don’t believe us?</p>
                      <a
                        href="https://youtube.com/shorts/njhKcqBpwEk?feature=share"
                        class="see-how-btn animation-btn"
                        target="_blank"
                        >See How
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="owl-item active"
                style="width: 464.667px; margin-right: 16px"
              >
                <div>
                  <div class="card team_mb_card truth-slide-card">
                    <div class="main-truth-content">
                      <div class="truth-slide-content">
                        <h3>‘Not investing’ is risky</h3>
                        <p>How?</p>
                      </div>
                      <div class="truths-investing-content-area">
                        <p>
                          <span class="check-icon"
                            ><img
                              src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                              class="img-responsive"
                              alt="team-img"
                              loading="lazy" /></span
                          ><span class="check-paragraph"
                            >Inflation, the rate of price increase, is at ~6% in
                            India</span
                          >
                        </p>
                        <p>
                          <span class="check-icon"
                            ><img
                              src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                              class="img-responsive"
                              alt="team-img"
                              loading="lazy" /></span
                          ><span class="check-paragraph"
                            >At a 6% inflation rate, ₹1 lakh cash today would
                            buy you things worth just ~₹22K after 25 years</span
                          >
                        </p>
                        <p>
                          <span class="check-icon"
                            ><img
                              src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                              class="img-responsive"
                              alt="team-img"
                              loading="lazy" /></span
                          ><span class="check-paragraph"
                            >The only way to beat inflation? Invest in inflation
                            beating assets like equity</span
                          >
                        </p>
                      </div>
                    </div>
                    <div class="truth-investing-btn">
                      <a
                        href="https://youtube.com/shorts/Zn00S5JpWpw?feature=share"
                        class="see-how-btn animation-btn"
                        target="_blank"
                        >Start Investing<span class="white-arrow"
                          ><img
                            src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/white-arrow.svg"
                            class="img-responsive"
                            alt="team-img"
                            loading="lazy"
                        /></span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="owl-item active"
                style="width: 464.667px; margin-right: 16px"
              >
                <div>
                  <div class="card team_mb_card truth-slide-card">
                    <div class="main-truth-content">
                      <div class="truth-slide-content">
                        <h3>Invest in Index Funds to match NIFTY 50 returns</h3>
                        <p>How?</p>
                      </div>
                      <div class="truths-investing-content-area">
                        <p>
                          <span class="check-icon"
                            ><img
                              src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                              class="img-responsive"
                              alt="team-img"
                              loading="lazy" /></span
                          ><span class="check-paragraph"
                            >NIFTY 50 is a portfolio of India’s Top 50
                            companies</span
                          >
                        </p>
                        <p>
                          <span class="check-icon"
                            ><img
                              src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                              class="img-responsive"
                              alt="team-img"
                              loading="lazy" /></span
                          ><span class="check-paragraph"
                            >Index Funds are a low cost way to track NIFTY 50
                            and invest in India’s growth</span
                          >
                        </p>
                        <p>
                          <span class="check-icon"
                            ><img
                              src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                              class="img-responsive"
                              alt="team-img"
                              loading="lazy" /></span
                          ><span class="check-paragraph"
                            >NIFTY 50 TRI has delivered ~13%+ annualised returns
                            since 1999</span
                          >
                        </p>
                      </div>
                    </div>
                    <div class="truth-investing-btn">
                      <a
                        href="https://bkafq.app.link/avbtrnRpnvb"
                        class="see-how-btn animation-btn"
                        target="_blank"
                        >Explore Index Funds
                        <span class="white-arrow"
                          ><img
                            src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/white-arrow.svg"
                            class="img-responsive"
                            alt="team-img"
                            loading="lazy"
                        /></span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="owl-item"
                style="width: 464.667px; margin-right: 16px"
              >
                <div>
                  <div class="card team_mb_card truth-slide-card">
                    <div class="main-truth-content">
                      <div class="truth-slide-content">
                        <h3>
                          Invest in stocks and save up to ₹46,800 in taxes!
                        </h3>
                        <p>How?</p>
                      </div>
                      <div class="truths-investing-content-area">
                        <p>
                          <span class="check-icon"
                            ><img
                              src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                              class="img-responsive"
                              alt="team-img"
                              loading="lazy" /></span
                          ><span class="check-paragraph"
                            >Protects your portfolio from downturns</span
                          >
                        </p>
                        <p>
                          <span class="check-icon"
                            ><img
                              src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                              class="img-responsive"
                              alt="team-img"
                              loading="lazy" /></span
                          ><span class="check-paragraph"
                            >Add Fixed Income Funds and Gold to your
                            portfolio</span
                          >
                        </p>
                        <p>
                          <span class="check-icon"
                            ><img
                              src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                              class="img-responsive"
                              alt="team-img"
                              loading="lazy" /></span
                          ><span class="check-paragraph"
                            >When markets are volatile, they keep your portfolio
                            steady</span
                          >
                        </p>
                      </div>
                    </div>
                    <div class="truth-investing-btn">
                      <a
                        href="/mutual-funds?cType=saveTaxes"
                        class="see-how-btn animation-btn"
                        >Explore Fixed Income Funds
                        <span class="white-arrow"
                          ><img
                            src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/white-arrow.svg"
                            class="img-responsive"
                            alt="team-img"
                            loading="lazy"
                        /></span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="owl-item"
                style="width: 464.667px; margin-right: 16px"
              >
                <div>
                  <div class="card team_mb_card truth-slide-card">
                    <div class="main-truth-content">
                      <div class="truth-slide-content">
                        <h3>Don’t put all your eggs in one basket!</h3>
                        <p>How?</p>
                      </div>
                      <div class="truths-investing-content-area">
                        <p>
                          <span class="check-icon"
                            ><img
                              src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                              class="img-responsive"
                              alt="team-img"
                              loading="lazy" /></span
                          ><span class="check-paragraph"
                            >Protects your portfolio from downturns</span
                          >
                        </p>
                        <p>
                          <span class="check-icon"
                            ><img
                              src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                              class="img-responsive"
                              alt="team-img"
                              loading="lazy" /></span
                          ><span class="check-paragraph"
                            >Add Fixed Income Funds and Gold to your
                            portfolio</span
                          >
                        </p>
                        <p>
                          <span class="check-icon"
                            ><img
                              src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                              class="img-responsive"
                              alt="team-img"
                              loading="lazy" /></span
                          ><span class="check-paragraph"
                            >When markets are volatile, they keep your portfolio
                            steady</span
                          >
                        </p>
                      </div>
                    </div>
                    <div class="truth-investing-btn">
                      <a
                        href="https://youtube.com/shorts/u1tGzENkloE?feature=share"
                        class="see-how-btn animation-btn"
                        target="_blank"
                        >Explore Fixed Income Funds
                        <span class="white-arrow"
                          ><img
                            src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/white-arrow.svg"
                            class="img-responsive"
                            alt="team-img"
                            loading="lazy"
                        /></span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="owl-item"
                style="width: 464.667px; margin-right: 16px"
              >
                <div>
                  <div class="card team_mb_card truth-slide-card">
                    <div class="main-truth-content">
                      <div class="truth-slide-content">
                        <h3>
                          Mutual Funds on Upstox are Direct Plans &amp; are free
                          of any charges!
                        </h3>
                        <p>How?</p>
                      </div>
                      <div class="truths-investing-content-area">
                        <p>
                          <span class="check-icon"
                            ><img
                              src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                              class="img-responsive"
                              alt="team-img"
                              loading="lazy" /></span
                          ><span class="check-paragraph"
                            >All Mutual Funds on Upstox are ‘Direct Plans’</span
                          >
                        </p>
                        <p>
                          <span class="check-icon"
                            ><img
                              src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                              class="img-responsive"
                              alt="team-img"
                              loading="lazy" /></span
                          ><span class="check-paragraph"
                            >Unlike Regular Plans, Direct Plans don’t charge
                            commissions</span
                          >
                        </p>
                        <p>
                          <span class="check-icon"
                            ><img
                              src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                              class="img-responsive"
                              alt="team-img"
                              loading="lazy" /></span
                          ><span class="check-paragraph"
                            >So, they’ll help you save up to 2% on costs &amp;
                            earn higher returns</span
                          >
                        </p>
                      </div>
                    </div>
                    <div class="truth-investing-btn">
                      <a
                        href="https://bkafq.app.link/2zghgoTlwwb"
                        class="see-how-btn animation-btn"
                        target="_blank"
                        >Ex Calculate now<span class="white-arrow"
                          ><img
                            src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/white-arrow.svg"
                            class="img-responsive"
                            alt="team-img"
                            loading="lazy"
                        /></span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- truth-investing-slider sec start here -->
    <section class="truth-investing-slider mobile-content">
      <div class="container">
        <div class="learn-upstox-title">
          <h2>Truths of investing</h2>
          <p>
            Why to invest? Where to invest? What to invest in? Follow these
            truths and you're set to begin!
          </p>
        </div>
        <div class="row">
          <div
            class="col-md-12 truth-investing slick-slider slick-dotted"
          >
                    <div
                      class="truth-investing-item"
                      style="width: 100%; display: inline-block"
                    >
                      <div class="item-content">
                        <p>Invest in stocks and save up to ₹46,800 in taxes!</p>
                        <button
                          type="button"
                          class="read-more-slide-btn"
                          data-toggle="modal"
                          data-target="#taxes"
                          tabindex="-1"
                        >
                          Read more
                        </button>
                      </div>
                      <div class="number-image">
                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/four.svg"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div
                      class="truth-investing-item"
                      style="width: 100%; display: inline-block"
                    >
                      <div class="item-content">
                        <p>Don’t put all your eggs in one basket!</p>
                        <button
                          type="button"
                          class="read-more-slide-btn"
                          data-toggle="modal"
                          data-target="#eggs"
                          tabindex="-1"
                        >
                          Read more
                        </button>
                      </div>
                      <div class="number-image">
                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/five.svg"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div
                      class="truth-investing-item"
                      style="width: 100%; display: inline-block"
                    >
                      <div class="item-content">
                        <p>
                          Mutual Funds on Upstox are Direct Plans &amp; are free
                          of any charges!
                        </p>
                        <button
                          type="button"
                          class="read-more-slide-btn"
                          data-toggle="modal"
                          data-target="#charges"
                          tabindex="-1"
                        >
                          Read more
                        </button>
                      </div>
                      <div class="number-image">
                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/six.svg"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div
                      class="truth-investing-item"
                      style="width: 100%; display: inline-block"
                    >
                      <div class="item-content">
                        <p>
                          A SIP of ₹5000/month started 25 years ago could've
                          made you a crorepati by now
                        </p>
                        <button
                          type="button"
                          class="read-more-slide-btn"
                          data-toggle="modal"
                          data-target="#sip"
                          tabindex="0"
                        >
                          Read more
                        </button>
                      </div>
                      <div class="number-image">
                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/number.svg"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div
                      class="truth-investing-item"
                      style="width: 100%; display: inline-block"
                    >
                      <div class="item-content">
                        <p>‘Not investing’ is risky</p>
                        <button
                          type="button"
                          class="read-more-slide-btn"
                          data-toggle="modal"
                          data-target="#risky"
                          tabindex="0"
                        >
                          Read more
                        </button>
                      </div>
                      <div class="number-image">
                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/two.svg"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div
                      class="truth-investing-item"
                      style="width: 100%; display: inline-block"
                    >
                      <div class="item-content">
                        <p>Invest in Index Funds to match NIFTY 50 returns</p>
                        <button
                          type="button"
                          class="read-more-slide-btn"
                          data-toggle="modal"
                          data-target="#returns"
                          tabindex="0"
                        >
                          Read more
                        </button>
                      </div>
                      <div class="number-image">
                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/three.svg"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div
                      class="truth-investing-item"
                      style="width: 100%; display: inline-block"
                    >
                      <div class="item-content">
                        <p>Invest in stocks and save up to ₹46,800 in taxes!</p>
                        <button
                          type="button"
                          class="read-more-slide-btn"
                          data-toggle="modal"
                          data-target="#taxes"
                          tabindex="-1"
                        >
                          Read more
                        </button>
                      </div>
                      <div class="number-image">
                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/four.svg"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div
                      class="truth-investing-item"
                      style="width: 100%; display: inline-block"
                    >
                      <div class="item-content">
                        <p>Don’t put all your eggs in one basket!</p>
                        <button
                          type="button"
                          class="read-more-slide-btn"
                          data-toggle="modal"
                          data-target="#eggs"
                          tabindex="-1"
                        >
                          Read more
                        </button>
                      </div>
                      <div class="number-image">
                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/five.svg"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <!-- <div
                      class="truth-investing-item"
                      style="width: 100%; display: inline-block"
                    >
                      <div class="item-content">
                        <p>
                          Mutual Funds on Upstox are Direct Plans &amp; are free
                          of any charges!
                        </p>
                        <button
                          type="button"
                          class="read-more-slide-btn"
                          data-toggle="modal"
                          data-target="#charges"
                          tabindex="-1"
                        >
                          Read more
                        </button>
                      </div>
                      <div class="number-image">
                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/six.svg"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div
                      class="truth-investing-item"
                      style="width: 100%; display: inline-block"
                    >
                      <div class="item-content">
                        <p>
                          A SIP of ₹5000/month started 25 years ago could've
                          made you a crorepati by now
                        </p>
                        <button
                          type="button"
                          class="read-more-slide-btn"
                          data-toggle="modal"
                          data-target="#sip"
                          tabindex="-1"
                        >
                          Read more
                        </button>
                      </div>
                      <div class="number-image">
                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/number.svg"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div
                      class="truth-investing-item"
                      style="width: 100%; display: inline-block"
                    >
                      <div class="item-content">
                        <p>‘Not investing’ is risky</p>
                        <button
                          type="button"
                          class="read-more-slide-btn"
                          data-toggle="modal"
                          data-target="#risky"
                          tabindex="-1"
                        >
                          Read more
                        </button>
                      </div>
                      <div class="number-image">
                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/two.svg"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div
                      class="truth-investing-item"
                      style="width: 100%; display: inline-block"
                    >
                      <div class="item-content">
                        <p>Invest in Index Funds to match NIFTY 50 returns</p>
                        <button
                          type="button"
                          class="read-more-slide-btn"
                          data-toggle="modal"
                          data-target="#returns"
                          tabindex="-1"
                        >
                          Read more
                        </button>
                      </div>
                      <div class="number-image">
                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/three.svg"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div
                      class="truth-investing-item"
                      style="width: 100%; display: inline-block"
                    >
                      <div class="item-content">
                        <p>Invest in stocks and save up to ₹46,800 in taxes!</p>
                        <button
                          type="button"
                          class="read-more-slide-btn"
                          data-toggle="modal"
                          data-target="#taxes"
                          tabindex="-1"
                        >
                          Read more
                        </button>
                      </div>
                      <div class="number-image">
                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/four.svg"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div
                      class="truth-investing-item"
                      style="width: 100%; display: inline-block"
                    >
                      <div class="item-content">
                        <p>Don’t put all your eggs in one basket!</p>
                        <button
                          type="button"
                          class="read-more-slide-btn"
                          data-toggle="modal"
                          data-target="#eggs"
                          tabindex="-1"
                        >
                          Read more
                        </button>
                      </div>
                      <div class="number-image">
                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/five.svg"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div
                      class="truth-investing-item"
                      style="width: 100%; display: inline-block"
                    >
                      <div class="item-content">
                        <p>
                          Mutual Funds on Upstox are Direct Plans &amp; are free
                          of any charges!
                        </p>
                        <button
                          type="button"
                          class="read-more-slide-btn"
                          data-toggle="modal"
                          data-target="#charges"
                          tabindex="-1"
                        >
                          Read more
                        </button>
                      </div>
                      <div class="number-image">
                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/six.svg"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </div>
                    </div> -->
          </div>
        </div>
      </div>
    </section>

    <!-- popup for mobile Start -->
    <section class="team_sec truths-investing-section mobile-popup">
      <div class="container">
        <div
          class="modal fade"
          id="sip"
          data-keyboard="false"
          data-backdrop="false"
        >
          <div class="card team_mb_card truth-slide-card lab-modal-body">
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">×</span
              ><span class="sr-only">Close</span>
            </button>
            <div class="main-truth-content">
              <div class="handle"><span></span></div>
              <div class="truth-slide-content">
                <h3>
                  A SIP of ₹5000/month started 25 years ago could've made you a
                  crorepati by now
                </h3>
                <div class="spanline">
                  <p>How?</p>
                  <span></span>
                </div>
              </div>
              <div class="truths-investing-content-area">
                <p>
                  <span class="check-icon"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy" /></span
                  ><span class="check-paragraph"
                    >Start a monthly SIP of ₹5,000</span
                  >
                </p>
                <p>
                  <span class="check-icon"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy" /></span
                  ><span class="check-paragraph"
                    >Stay invested for 25+ years</span
                  >
                </p>
                <p>
                  <span class="check-icon"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy" /></span
                  ><span class="check-paragraph"
                    >Aim for equity style returns of 12.5%+ to enjoy the magic
                    of compounding</span
                  >
                </p>
              </div>

              <div class="truth-investing-btn">
                <p>Don’t believe us?</p>
                <a
                  href="https://youtube.com/shorts/njhKcqBpwEk?feature=share"
                  class="see-how-btn animation-btn"
                  target="_blank"
                  >See How
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          class="modal fade"
          id="risky"
          data-keyboard="false"
          data-backdrop="false"
        >
          <div class="card team_mb_card truth-slide-card lab-modal-body">
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">×</span
              ><span class="sr-only">Close</span>
            </button>
            <div class="main-truth-content">
              <div class="handle"><span></span></div>
              <div class="truth-slide-content">
                <h3>‘Not investing’ is risky</h3>
                <div class="spanline">
                  <p>How?</p>
                  <span></span>
                </div>
              </div>
              <div class="truths-investing-content-area">
                <p>
                  <span class="check-icon"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy" /></span
                  ><span class="check-paragraph"
                    >Inflation, the rate of price increase, is at ~6% in
                    India</span
                  >
                </p>
                <p>
                  <span class="check-icon"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy" /></span
                  ><span class="check-paragraph"
                    >At a 6% inflation rate, ₹1 lakh cash today would buy you
                    things worth just ~₹22K after 25 years</span
                  >
                </p>
                <p>
                  <span class="check-icon"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy" /></span
                  ><span class="check-paragraph"
                    >The only way to beat inflation? Invest in inflation beating
                    assets like equity</span
                  >
                </p>
              </div>

              <div class="truth-investing-btn">
                <a
                  href="https://youtube.com/shorts/Zn00S5JpWpw?feature=share"
                  class="see-how-btn animation-btn"
                  target="_blank"
                  >Start Investing<span class="white-arrow"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/white-arrow.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy"
                  /></span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          class="modal fade"
          id="returns"
          data-keyboard="false"
          data-backdrop="false"
        >
          <div class="card team_mb_card truth-slide-card lab-modal-body">
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">×</span
              ><span class="sr-only">Close</span>
            </button>
            <div class="main-truth-content">
              <div class="handle"><span></span></div>
              <div class="truth-slide-content">
                <h3>Invest in Index Funds to match NIFTY 50 returns</h3>
                <div class="spanline">
                  <p>How?</p>
                  <span></span>
                </div>
              </div>
              <div class="truths-investing-content-area">
                <p>
                  <span class="check-icon"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy" /></span
                  ><span class="check-paragraph"
                    >NIFTY 50 is a portfolio of India’s Top 50 companies</span
                  >
                </p>
                <p>
                  <span class="check-icon"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy" /></span
                  ><span class="check-paragraph"
                    >Index Funds are a low cost way to track NIFTY 50 and invest
                    in India’s growth</span
                  >
                </p>
                <p>
                  <span class="check-icon"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy" /></span
                  ><span class="check-paragraph"
                    >NIFTY 50 TRI has delivered ~13%+ annualised returns since
                    1999</span
                  >
                </p>
              </div>

              <div class="truth-investing-btn">
                <a
                  href="https://bkafq.app.link/avbtrnRpnvb"
                  class="see-how-btn animation-btn"
                  target="_blank"
                  >Explore Index Funds
                  <span class="white-arrow"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/white-arrow.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy"
                  /></span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal fade"
          id="taxes"
          data-keyboard="false"
          data-backdrop="false"
        >
          <div class="card team_mb_card truth-slide-card lab-modal-body">
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">×</span
              ><span class="sr-only">Close</span>
            </button>
            <div class="main-truth-content">
              <div class="handle"><span></span></div>
              <div class="truth-slide-content">
                <h3>Invest in stocks and save up to ₹46,800 in taxes!</h3>
                <div class="spanline">
                  <p>How?</p>
                  <span></span>
                </div>
              </div>
              <div class="truths-investing-content-area">
                <p>
                  <span class="check-icon"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy" /></span
                  ><span class="check-paragraph"
                    >Protects your portfolio from downturns</span
                  >
                </p>
                <p>
                  <span class="check-icon"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy" /></span
                  ><span class="check-paragraph"
                    >Add Fixed Income Funds and Gold to your portfolio</span
                  >
                </p>
                <p>
                  <span class="check-icon"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy" /></span
                  ><span class="check-paragraph"
                    >When markets are volatile, they keep your portfolio
                    steady</span
                  >
                </p>
              </div>

              <div class="truth-investing-btn">
                <a
                  href="/mutual-funds?cType=saveTaxes"
                  class="see-how-btn animation-btn"
                  >Explore Fixed Income Funds
                  <span class="white-arrow"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/white-arrow.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy"
                  /></span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal fade"
          id="eggs"
          data-keyboard="false"
          data-backdrop="false"
        >
          <div class="card team_mb_card truth-slide-card lab-modal-body">
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">×</span
              ><span class="sr-only">Close</span>
            </button>
            <div class="main-truth-content">
              <div class="handle"><span></span></div>
              <div class="truth-slide-content">
                <h3>Don’t put all your eggs in one basket!</h3>
                <div class="spanline">
                  <p>How?</p>
                  <span></span>
                </div>
              </div>
              <div class="truths-investing-content-area">
                <p>
                  <span class="check-icon"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy" /></span
                  ><span class="check-paragraph"
                    >Protects your portfolio from downturns</span
                  >
                </p>
                <p>
                  <span class="check-icon"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy" /></span
                  ><span class="check-paragraph"
                    >Add Fixed Income Funds and Gold to your portfolio</span
                  >
                </p>
                <p>
                  <span class="check-icon"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy" /></span
                  ><span class="check-paragraph"
                    >When markets are volatile, they keep your portfolio
                    steady</span
                  >
                </p>
              </div>

              <div class="truth-investing-btn">
                <a
                  href="https://youtube.com/shorts/u1tGzENkloE?feature=share"
                  class="see-how-btn animation-btn"
                  target="_blank"
                  >Explore Fixed Income Funds
                  <span class="white-arrow"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/white-arrow.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy"
                  /></span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal fade"
          id="charges"
          data-keyboard="false"
          data-backdrop="false"
        >
          <div class="card team_mb_card truth-slide-card lab-modal-body">
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">×</span
              ><span class="sr-only">Close</span>
            </button>
            <div class="main-truth-content">
              <div class="handle"><span></span></div>
              <div class="truth-slide-content">
                <h3>
                  Mutual Funds on Upstox are Direct Plans &amp; are free of any
                  charges!
                </h3>
                <div class="spanline">
                  <p>How?</p>
                  <span></span>
                </div>
              </div>
              <div class="truths-investing-content-area">
                <p>
                  <span class="check-icon"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy" /></span
                  ><span class="check-paragraph"
                    >All Mutual Funds on Upstox are ‘Direct Plans’</span
                  >
                </p>
                <p>
                  <span class="check-icon"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy" /></span
                  ><span class="check-paragraph"
                    >Unlike Regular Plans, Direct Plans don’t charge
                    commissions</span
                  >
                </p>
                <p>
                  <span class="check-icon"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/slide-checkbox.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy" /></span
                  ><span class="check-paragraph"
                    >So, they’ll help you save up to 2% on costs &amp; earn
                    higher returns</span
                  >
                </p>
              </div>

              <div class="truth-investing-btn">
                <a
                  href="https://bkafq.app.link/2zghgoTlwwb"
                  class="see-how-btn animation-btn"
                  target="_blank"
                  >Ex Calculate now<span class="white-arrow"
                    ><img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/white-arrow.svg"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy"
                  /></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- popup for mobile end -->

    <!-- truth-investing-slider sec end here -->

    <!-- end of toggle section -->
    <section class="invest_section invest-sec2">
      <div class="container container_primary">
        <div class="dsktp-hide">
          <div class="sections">
            <div class="pddg_sec trade second-trade" id="trade">
              <div class="row">
                <div class="col-md-5 pddg_col">
                  <div class="tab-content">
                    <div
                      role="tabpanel"
                      class="tab-pane fade"
                      id="powerful-charting"
                    >
                      <picture>
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/etf-tab11.webp
                          "
                          class="img-responsive"
                          media="(min-width: 767px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/etf-tab11.png
                          "
                          class="img-responsive"
                          media="(min-width: 768px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/etf-tab11.png"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </picture>
                    </div>
                    <div
                      role="tabpanel"
                      class="tab-pane fade active in"
                      id="powerful-discovery"
                    >
                      <picture>
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/etf-tab21.webp
                          "
                          class="img-responsive"
                          media="(min-width: 767px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/etf-tab21.png
                          "
                          class="img-responsive"
                          media="(min-width: 768px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/etf-tab21.png"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </picture>
                    </div>
                    <div
                      role="tabpanel"
                      class="tab-pane fade"
                      id="powerful-executive"
                    >
                      <picture>
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/etf-tab31.webp
                          "
                          class="img-responsive"
                          media="(min-width: 767px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/etf-tab31.png
                          "
                          class="img-responsive"
                          media="(min-width: 768px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/etf-tab31.png"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </picture>
                    </div>
                  </div>
                </div>

                <div class="col-md-7 pddg_col">
                  <div class="int_tab_list">
                    <h2 class="h2_heading">ETFs</h2>
                    <p class="p_txt">
                      Top ETFs shortlisted based on both risk and return
                      analysis
                    </p>
                    <ul class="list-unstyled" role="tablist">
                      <li role="presentation" class="">
                        <a
                          href="#powerful-charting"
                          aria-controls="powerful-charting"
                          role="tab"
                          data-toggle="tab"
                          aria-expanded="false"
                        >
                          <h3>Discover ETFs easily</h3>
                          <ul class="list-unstyled">
                            <li>
                              With dedicated Smartlists for ETFs - Trending
                              ETFs, Gold ETFs, International ETFs, Equity ETFs,
                              Debt ETFs
                            </li>
                          </ul>
                        </a>
                      </li>
                      <li role="presentation" class="active">
                        <a
                          href="#powerful-discovery"
                          aria-controls="powerful-discovery"
                          role="tab"
                          data-toggle="tab"
                          aria-expanded="true"
                        >
                          <h3>Invest in them confidently</h3>
                          <ul class="list-unstyled">
                            <li>
                              View ETF details - liquidity, fund size, expense
                              ratio, tracking error, Returns vs FD.
                            </li>
                          </ul>
                        </a>
                      </li>
                      <li role="presentation" class="">
                        <a
                          href="#powerful-executive"
                          aria-controls="powerful-executive"
                          role="tab"
                          data-toggle="tab"
                          aria-expanded="false"
                        >
                          <h3>Learn when to buy or sell</h3>
                          <ul class="list-unstyled">
                            <li>
                              Details on ETF trading at a premium or discount to
                              help you decide whether to buy this ETF now or
                              later
                            </li>
                          </ul>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="pddg_sec trade second-trade" id="sgbs">
              <div class="row sgbs_inner_row">
                <div class="col-md-6 pddg_col sgbs_content">
                  <h2 class="h2_heading">
                    SGBs<span class="new-text">New</span>
                  </h2>
                  <p>
                    One of the best ways to invest in gold!<br />
                    Government securities denominated in grams of gold,<br />
                    a great and safe alternative to holding physical gold
                  </p>
                </div>

                <div class="col-md-6 pddg_col sgbs_img">
                  <ul class="backend-rbi">
                    <li>
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/green.svg"
                        alt="checked"
                        loading="lazy"
                      />
                      <h5>Safe as its backed by RBI and GOI</h5>
                    </li>
                    <li>
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/green.svg"
                        alt="checked"
                        loading="lazy"
                      />
                      <h5>Benefit from gold price rise</h5>
                    </li>
                    <li>
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/green.svg"
                        alt="checked"
                        loading="lazy"
                      />
                      <h5>Earn 2.5% interest</h5>
                    </li>
                    <li>
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/green.svg"
                        alt="checked"
                        loading="lazy"
                      />
                      <h5>Tax-friendly</h5>
                    </li>
                  </ul>
                  <a
                    href="/mutual-funds/"
                    class="btn prple_outline_btn uplearn_btn upcoming-btn"
                    target="_blank"
                    >Explore Upcoming SGBs</a
                  >
                </div>
              </div>
            </div>

            <div class="pddg_sec invest third-trade" id="invest">
              <div class="row">
                <div class="col-md-5 pddg_col">
                  <div class="tab-content">
                    <div
                      role="tabpanel"
                      class="tab-pane fade"
                      id="invest-idea-ipo"
                    >
                      <picture>
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/ipo-tab1.webp
                          "
                          class="img-responsive"
                          media="(min-width: 767px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/ipo-tab1.png
                          "
                          class="img-responsive"
                          media="(min-width: 768px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/ipo-tab1.png"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </picture>
                    </div>
                    <div
                      role="tabpanel"
                      class="tab-pane fade active in"
                      id="new-sights-ipo"
                    >
                      <picture>
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/ipo-tab2.webp
                          "
                          class="img-responsive"
                          media="(min-width: 767px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/ipo-tab2.png
                          "
                          class="img-responsive"
                          media="(min-width: 768px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/ipo-tab2.png"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </picture>
                    </div>
                    <div
                      role="tabpanel"
                      class="tab-pane fade"
                      id="order-place-ipo"
                    >
                      <picture>
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/ipo-tab3.webp
                          "
                          class="img-responsive"
                          media="(min-width: 767px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/ipo-tab3.png
                          "
                          class="img-responsive"
                          media="(min-width: 768px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/ipo-tab3.png"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </picture>
                    </div>
                  </div>
                </div>
                <div class="col-md-7 pddg_col">
                  <div class="int_tab_list">
                    <h2 class="h2_heading">IPOs</h2>
                    <p class="p_txt">
                      Enjoy the latest IPOs at ₹0* commissions
                    </p>
                    <ul class="list-unstyled" role="tablist">
                      <li role="presentation" class="">
                        <a
                          href="#invest-idea-ipo"
                          aria-controls="invest-idea-ipo"
                          role="tab"
                          data-toggle="tab"
                          aria-expanded="false"
                        >
                          <h3>Get alerted about every IPO</h3>
                        </a>
                      </li>
                      <li role="presentation" class="active">
                        <a
                          href="#new-sights-ipo"
                          aria-controls="new-sights-ipo"
                          role="tab"
                          data-toggle="tab"
                          aria-expanded="true"
                        >
                          <h3>Invest in them with just a few clicks</h3>
                        </a>
                      </li>
                      <li role="presentation" class="">
                        <a
                          href="#order-place-ipo"
                          aria-controls="order-place-ipo"
                          role="tab"
                          data-toggle="tab"
                          aria-expanded="false"
                        >
                          <h3>
                            Apply before others with the ‘pre-apply’ feature
                          </h3>
                        </a>
                      </li>
                    </ul>
                    <a
                      href="/ipo-initial-public-offering"
                      class="btn prple_outline_btn uplearn_btn"
                      target="_blank"
                      >Explore Upcoming IPOs</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mbile-hide">
          <div class="mbl_invest">
            <div class="text-center">
              <h2 class="h2_heading">ETFs</h2>
              <p class="p_txt">
                Top ETFs shortlisted based on both risk and return analysis
              </p>
            </div>
            <div class="invest-slide-arrow" id="invest-slide-upstox">
              <div
                class="invest_next invest-arrow invest-trade-upstox active"
                id="trading_next"
              >
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/equity-trading/invest-next.svg"
                  class="img-responsive"
                  alt="invest-next"
                  loading="lazy"
                />
              </div>

              <div
                class="invest_prev invest-arrow invest-trade-upstox"
                id="trading_prev"
              >
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/equity-trading/invest-prev.svg"
                  class="img-responsive"
                  alt="invest-prev"
                  loading="lazy"
                />
              </div>
            </div>

            <div class="pddg_sec invest tab-sec2" id="upstox-invest">
              <div class="row">
                <div class="col-md-5">
                  <div class="mbl_sec_list">
                    <ul class="list-unstyled-trading" role="tablist">
                      <li role="presentation" class="active">
                        <a
                          href="#invest-idea-mobile-ipo"
                          aria-controls="invest-idea-mobile-ipo"
                          role="tab"
                          data-toggle="tab"
                        >
                        </a>
                      </li>
                      <li role="presentation">
                        <a
                          href="#new-sights-mobile-ipo"
                          aria-controls="new-sights-mobile-ipo"
                          role="tab"
                          data-toggle="tab"
                        >
                        </a>
                      </li>
                      <li role="presentation">
                        <a
                          href="#order-place-mobile-ipo"
                          aria-controls="order-place-mobile-ipo"
                          role="tab"
                          data-toggle="tab"
                        >
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-7 etf">
                  <div class="tab-content">
                    <div
                      role="tabpanel"
                      class="tab-pane fade in active"
                      id="invest-idea-mobile-ipo"
                    >
                      <picture>
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/etf-tab1-mob.webp
                          "
                          class="img-responsive"
                          media="(min-width: 767px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/etf-tab1-mob.png
                          "
                          class="img-responsive"
                          media="(min-width: 768px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/etf-tab1-mob.png"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </picture>
                      <div class="rated-mobile-sub">
                        <h3>Discover ETFs easily</h3>
                        <p>
                          With dedicated Smartlists for ETFs - Trending ETFs,
                          Gold ETFs, International ETFs, Equity ETFs, Debt ETFs
                        </p>
                      </div>
                    </div>
                    <div
                      role="tabpanel"
                      class="tab-pane fade"
                      id="new-sights-mobile-ipo"
                    >
                      <picture>
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/etf-tab2-mob.webp
                          "
                          class="img-responsive"
                          media="(min-width: 767px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/etf-tab2-mob.png
                          "
                          class="img-responsive"
                          media="(min-width: 768px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/etf-tab2-mob.png"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </picture>

                      <div class="rated-mobile-sub">
                        <h3>Invest in them confidently</h3>
                        <p>
                          View ETF details - liquidity, fund size, expense
                          ratio, tracking error, Returns vs FD.
                        </p>
                      </div>
                    </div>
                    <div
                      role="tabpanel"
                      class="tab-pane fade"
                      id="order-place-mobile-ipo"
                    >
                      <picture>
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/etf-tab3-mob.webp
                          "
                          class="img-responsive"
                          media="(min-width: 767px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/etf-tab3-mob.png
                          "
                          class="img-responsive"
                          media="(min-width: 768px)"
                          alt="upstox-img"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/etf-tab3-mob.png"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </picture>

                      <div class="rated-mobile-sub">
                        <h3>Learn when to buy or sell</h3>
                        <p>
                          Details on ETF trading at a premium or discount to
                          help you decide whether to buy this ETF now or later
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="pddg_sec trade second-trade" id="sgbs">
            <div class="row sgbs_inner_row">
              <div class="col-md-6 pddg_col sgbs_content">
                <h2 class="h2_heading">
                  SGBs<span class="new-text">New</span>
                </h2>
                <p>
                  One of the best ways to invest in gold!<br />
                  Government securities denominated in grams of gold,<br />
                  a great and safe alternative to holding physical gold
                </p>
              </div>

              <div class="col-md-6 pddg_col sgbs_img">
                <ul class="backend-rbi">
                  <li>
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/green.svg"
                      alt="checked"
                      loading="lazy"
                    />
                    <h5>Safe as its backed by RBI and GOI</h5>
                  </li>
                  <li>
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/green.svg"
                      alt="checked"
                      loading="lazy"
                    />
                    <h5>Benefit from gold price rise</h5>
                  </li>
                  <li>
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/green.svg"
                      alt="checked"
                      loading="lazy"
                    />
                    <h5>Earn 2.5% interest</h5>
                  </li>
                  <li>
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/green.svg"
                      alt="checked"
                      loading="lazy"
                    />
                    <h5>Tax-friendly</h5>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- mutual funds section start here -->
    <section class="invest_section invest-sec2 mutual-funds-sec">
      <div class="container container_primary">
        <div class="mbile-hide">
          <div class="mbl_invest">
            <div class="text-center">
              <h2 class="h2_heading">IPOs</h2>
              <p class="p_txt">Enjoy the latest IPOs at ₹0* commissions</p>
            </div>
            <div class="invest-slide-arrow" id="slide-mutual">
              <div
                class="invest_next invest-arrow invest-arrow-power active"
                id="trading_next_power"
              >
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/equity-trading/invest-next.svg"
                  class="img-responsive"
                  alt="invest-next"
                  loading="lazy"
                />
              </div>

              <div
                class="invest_prev invest-arrow invest-arrow-power"
                id="trading_prev_power"
              >
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/equity-trading/invest-prev.svg"
                  class="img-responsive"
                  alt="invest-prev"
                  loading="lazy"
                />
              </div>
            </div>

            <div class="pddg_sec invest tab-sec2" id="invest-power">
              <div class="row">
                <div class="col-md-5">
                  <div class="mbl_sec_list">
                    <ul
                      class="list-unstyled"
                      id="list-unstyled-power"
                      role="tablist"
                    >
                      <li role="presentation" class="active">
                        <a
                          href="#invest-idea-mobile-imu"
                          aria-controls="invest-idea-mobile-imu"
                          role="tab"
                          data-toggle="tab"
                        >
                        </a>
                      </li>
                      <li role="presentation">
                        <a
                          href="#new-sights-mobile-imu"
                          aria-controls="new-sights-mobile-imu"
                          role="tab"
                          data-toggle="tab"
                        >
                        </a>
                      </li>
                      <li role="presentation">
                        <a
                          href="#order-place-mobile-imu"
                          aria-controls="order-place-mobile-imu"
                          role="tab"
                          data-toggle="tab"
                        >
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-7 trades-ipo">
                  <div class="tab-content">
                    <div
                      role="tabpanel"
                      class="tab-pane fade in active"
                      id="invest-idea-mobile-imu"
                    >
                      <picture>
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/commissions-mob-tab.webp
                          "
                          class="img-responsive"
                          alt="upstox-img"
                          media="(min-width: 767px)"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/commissions-mob-tab.png
                          "
                          class="img-responsive"
                          alt="upstox-img"
                          media="(min-width: 768px)"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/commissions-mob-tab.png"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </picture>

                      <div class="rated-mobile-sub">
                        <h3>Get alerted about every IPO</h3>
                        <!-- <p>With dedicated Smartlists for ETFs - Trending ETFs, Gold ETFs, International ETFs, Equity ETFs, Debt ETFs</p> -->
                      </div>
                    </div>
                    <div
                      role="tabpanel"
                      class="tab-pane fade"
                      id="new-sights-mobile-imu"
                    >
                      <picture>
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/commissions-mob-tab1.webp
                          "
                          class="img-responsive"
                          alt="upstox-img"
                          media="(min-width: 767px)"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/commissions-mob-tab1.png
                          "
                          class="img-responsive"
                          alt="upstox-img"
                          media="(min-width: 768px)"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/commissions-mob-tab1.png"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </picture>

                      <div class="rated-mobile-sub">
                        <h3>Invest in them with just a few clicks</h3>
                        <!-- <p>View ETF details - liquidity, fund size, expense ratio, tracking error, Returns vs FD.</p> -->
                      </div>
                    </div>
                    <div
                      role="tabpanel"
                      class="tab-pane fade"
                      id="order-place-mobile-imu"
                    >
                      <picture>
                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/commissions-mob-tab2.webp
                          "
                          class="img-responsive"
                          alt="upstox-img"
                          media="(min-width: 767px)"
                          loading="lazy"
                          type="image/webp"
                        />

                        <source
                          srcset="
                            https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/commissions-mob-tab2.png
                          "
                          class="img-responsive"
                          alt="upstox-img"
                          media="(min-width: 768px)"
                          loading="lazy"
                          type="image/png"
                        />

                        <img
                          src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/commissions-mob-tab2.png"
                          class="img-responsive"
                          alt="upstox-img"
                          loading="lazy"
                        />
                      </picture>

                      <div class="rated-mobile-sub">
                        <h3>
                          Apply before others with <br />the ‘pre-apply’ feature
                        </h3>
                        <!-- <p>Details on ETF trading at a premium or discount to help you decide whether to buy this ETF now or later</p> -->
                      </div>
                    </div>
                  </div>
                  <a
                    href="/ipo-initial-public-offering"
                    class="btn prple_outline_btn uplearn_btn"
                    target="_blank"
                    >Explore Upcoming IPOs</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- stock market section start here-->
    <section class="stock-market-sec desktop-content">
      <div class="container">
        <div class="stock-market-sec-title-text">
          <h2>Uplearn</h2>
          <p>New to the stock market or wish to upskill?</p>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="stock-market-column">
              <a href="/uplearn/">
                <div class="stock-market-img">
                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/webinars.svg"
                    alt="courses"
                    loading="lazy"
                  />
                </div>
                <h3>Courses</h3>
                <p>Self-Help Courses on Options Trading With Quizzes!</p>
              </a>
            </div>
          </div>

          <div class="col-md-4">
            <div class="stock-market-column">
              <a href="/uplearn/">
                <div class="stock-market-img">
                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/courses.svg"
                    alt="webinars"
                    loading="lazy"
                  />
                </div>
                <h3>Webinars</h3>
                <p>
                  Risk Management, Options Trading, Technical Analysis and More
                </p>
              </a>
            </div>
          </div>

          <div class="col-md-4">
            <div class="stock-market-column">
              <a href="/uplearn/">
                <div class="stock-market-img">
                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/quick.svg"
                    alt="quick"
                    loading="lazy"
                  />
                </div>
                <h3>Quick Videos</h3>
                <p>On Stocks, Mutual Funds, IPOs, Gold and More.</p>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="uplearn-main-btn">
        <a
          href="/uplearn/"
          class="btn prple_outline_btn uplearn_btn"
          >Learn with us!</a
        >
      </div>
    </section>
    <!-- stock market section end here-->

    <section class="team_sec main_word take_word">
      <div class="container">
        <div class="mbile-hide">
          <h2 class="h2_heading team-sec-title">Don't take our word for it</h2>
          <div
            class="team_mb_slider global_slick_dots owl-carousel owl-theme owl-loaded owl-drag"
          >
            <div class="owl-stage-outer">
              <div
                class="owl-stage"
                style="
                  transform: translate3d(0px, 0px, 0px);
                  transition: all;
                  width: 2473px;
                  padding-left: 1px;
                  padding-right: 1px;
                "
              >
                <div
                  class="owl-item active"
                  style="width: 337px; margin-right: 16px"
                >
                  <div>
                    <div class="card team_mb_card investor-slide-card">
                      <div class="slider-text-content">
                        <p>
                          One of the best application for investing and trading.
                          UI is very simple. The best thing I love about this
                          app is it's customer executive, they deal with each
                          and every problem you face as early as possible...
                          Thanks for making my investment so easy…
                        </p>
                      </div>
                      <div class="team-img-text-content">
                        <h5>Jitendra kumar</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="owl-item active"
                  style="width: 337px; margin-right: 16px"
                >
                  <div>
                    <div class="card team_mb_card">
                      <div class="slider-text-content">
                        <p>
                          The new Upstox upgrade is great. Company Financials,
                          Charts, News are all in one place. Helped me avoid
                          jumping across apps. Now, I'd like to keep Upstox
                          always running without logging out!
                        </p>
                      </div>
                      <div class="team-img-text-content">
                        <h5>Siva prasad</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="owl-item active"
                  style="width: 337px; margin-right: 16px"
                >
                  <div>
                    <div class="card team_mb_card">
                      <div class="slider-text-content">
                        <p>
                          Best app ever! Upstox provides news, charts, summary,
                          P&amp;L, funds balance, etc .. And all features are
                          just amazing. The screen is attractive and easy to use
                          for beginners too.
                        </p>
                      </div>
                      <div class="team-img-text-content">
                        <h5>Manjushree</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="owl-item active"
                  style="width: 337px; margin-right: 16px"
                >
                  <div>
                    <div class="card team_mb_card">
                      <div class="slider-text-content">
                        <p>
                          In my opinion upstox is the best app I have ever used.
                          Because its customer service is unsurpassed and
                          provides easy interface for users . That's why anyone
                          can run and understand this app without any problem.
                          This app should be the first choice for beginners. And
                          everything from investing to trading is available in
                          this app. My personal favourite is in this app divide
                          into 2 segments. One for investors and another for
                          traders.
                        </p>
                      </div>
                      <div class="team-img-text-content">
                        <h5>Arabinda Panda</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="owl-item" style="width: 337px; margin-right: 16px">
                  <div>
                    <div class="card team_mb_card">
                      <div class="slider-text-content">
                        <p>
                          Day by day upstox is improving this app just
                          mind-blowing. very smooth and very user friendly for
                          an option trader.
                        </p>
                      </div>
                      <div class="team-img-text-content">
                        <h5>Subhankar Das</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="owl-item" style="width: 337px; margin-right: 16px">
                  <div>
                    <div class="card team_mb_card">
                      <div class="slider-text-content">
                        <p>
                          Such a brilliant and user friendly interface for
                          investors and traders both ... Best treding
                          experience, I just can't imagine to shift in any other
                          brokers.
                        </p>
                      </div>
                      <div class="team-img-text-content">
                        <h5>Debojit Raha</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="owl-item" style="width: 337px; margin-right: 16px">
                  <div>
                    <div class="card team_mb_card">
                      <div class="slider-text-content">
                        <p>
                          Super smooth and friendly with new traders or
                          investor. Keep updated with chart and maintain your
                          dignity always as usual.
                        </p>
                      </div>
                      <div class="team-img-text-content">
                        <h5>Sumit</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="download_apps">
      <div class="container container_primary">
        <div
          class="row"
          data-aos="fade-zoom-in"
          data-aos-easing="ease-in-back"
          data-aos-duration="1000"
          data-aos-offset="0"
        >
          <div class="col-md-6 col-sm-6 downlaod-column">
            <h2 class="h2_heading">
              Download One of India's Best Trading Apps
            </h2>
            <h5>
              <span
                ><img
                  src="https://upstox.com/app/themes/upstox/dist/img/mutual-fund-new/star_icon.svg"
                  alt="star-icon"
                  loading="lazy" /></span
              ><strong>4.5+</strong>Avg. App Rating
            </h5>
            <ul class="list-unstyled">
              <li>
                <a href="https://play.google.com/store/apps/details?id=com.jobvim.expensetoday&pcampaignid=web_share" target="_blank">
                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/g-ply-icon.svg"
                    alt="Play store"
                    loading="lazy"
                /></a>
              </li>
              <li>
                <a href="https://apps.apple.com/cn/app/mioduvac/id6745430658" target="_blank">
                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/ios_icon.svg"
                    alt="App store"
                    loading="lazy"
                /></a>
              </li>
            </ul>
          </div>
          <div class="col-md-6 col-sm-6 download-img-column">
            <picture class="dsktp-hide">
              <source
                srcset="
                  https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/download_app_img_desktop.webp
                "
                class="img-responsive"
                alt="phone-img"
                loading="lazy"
                media="(min-width: 767px)"
                type="image/webp"
              />

              <source
                srcset="
                  https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/download_app_img_desktop.png
                "
                class="img-responsive"
                alt="phone-img"
                loading="lazy"
                media="(min-width: 768px)"
                type="image/png"
              />

              <img
                src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/download_app_img_desktop.png"
                class="img-responsive"
                alt="phone-img"
                loading="lazy"
              />
            </picture>
            <!-- responsive-img -->
            <picture class="mbile-hide">
              <source
                srcset="
                  https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/download-mobile.webp
                "
                class="img-responsive"
                alt="phone-img"
                loading="lazy"
                media="(min-width: 767px)"
                type="image/webp"
              />

              <source
                srcset="
                  https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/download-mobile.png
                "
                class="img-responsive"
                alt="phone-img"
                loading="lazy"
                media="(min-width: 768px)"
                type="image/png"
              />

              <img
                src="https://upstox.com/app/themes/upstox/dist/img/invest-in-share-market/download-mobile.png"
                class="img-responsive"
                alt="phone-img"
                loading="lazy"
              />
            </picture>
            <!-- responsive-img -->
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<style src="@/styles/3-modules/upstox-redesign-base.scss" lang="scss" scoped></style>
<style src="@/styles/2-layouts/invest-in-share-market.scss" lang="scss" scoped></style>
<style src="@/styles/2-layouts/seo-calculators.scss" lang="scss" scoped></style>
<style src="@/styles/css/mutual-fund-new.scss" lang="scss" scoped></style>
<style scoped lang="scss">
</style>
